import { useCurrencyAmountFormatter } from '@routable/shared';
import indefinite from 'indefinite';
import React, { useMemo } from 'react';
import BaseHint from 'components/hintTypes/BaseHint';
import { RoutableFeesLink } from 'components/linkTypes';
import { CurrencyCode } from 'constants/currency';
import { Intent } from 'constants/ui';
import { isBillingCodeAchAddenda } from 'helpers/billing/base';
import helpDocs from 'helpers/helpDocs';
import { multiplyFloat } from 'helpers/math';
import {} from './FundingProviderMemoTransactionCostHint.types';
const FundingProviderMemoTransactionCostHint = ({ billingData }) => {
    const { formatCurrencyAmount } = useCurrencyAmountFormatter();
    const transactionFeeText = useMemo(() => {
        const recordType = isBillingCodeAchAddenda(billingData.code) ? 'addenda record' : 'remittance info';
        const { minAmount, multiplier } = billingData;
        const bps = multiplyFloat(multiplier, 10000);
        const baseText = `Adding ${indefinite(recordType)} will cost`;
        if (bps === 0) {
            return `${baseText} ${formatCurrencyAmount({ amount: 0, currency: CurrencyCode.USD })} per transaction.`;
        }
        if (!minAmount || parseFloat(minAmount) <= 0) {
            return `${baseText} an additional ${bps} basis points per transaction.`;
        }
        return `${baseText} an additional ${bps} basis points per transaction, with a minimum charge of ${formatCurrencyAmount({ amount: minAmount, currency: CurrencyCode.USD })}.`;
    }, [billingData, formatCurrencyAmount]);
    return (React.createElement(BaseHint, { intent: Intent.INFO, title: React.createElement(React.Fragment, null,
            transactionFeeText,
            " ",
            React.createElement(RoutableFeesLink, { className: "primary bold", href: helpDocs.ADDENDA_RECORDS })), titleProps: { marginBottom: false } }));
};
export default FundingProviderMemoTransactionCostHint;
